import { useRef } from 'react'
import isEqual from 'lodash/isEqual'

/**
 * Returns a memoized object reference when the new value is the same as the last one.
 * Using lodash isEqual for comparison. Not recommended for really big objects.
 * @param value
 * @returns {*}
 */
export function useRefMemo (value) {
  const cache = useRef(null)
  if (!isEqual(cache.current, value)) {
    cache.current = value
  }
  return cache.current
}



// WEBPACK FOOTER //
// ./src/hooks/useRefMemo.js